import { render, staticRenderFns } from "./WorkerDetail.vue?vue&type=template&id=46a98474&"
import script from "./WorkerDetail.vue?vue&type=script&lang=js&"
export * from "./WorkerDetail.vue?vue&type=script&lang=js&"
import style0 from "./WorkerDetail.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports